export const shouldHighlight = (
  active: boolean,
  startTime: number,
  currentTime: number,
  isRealTimeTranscription: boolean
) => active && !isRealTimeTranscription && currentTime >= startTime;
